(function($) {
  
  $(document).ready(function() {
    
  });
  
})(jQuery);

function initFooterMenu(){
  var $ = jQuery;
  $('.has-submenu .sec-title').click(function(){
    var isactive = false;
    if($(this).parent().hasClass('is-menu-active')){ isactive = true; }
    $('.block.has-submenu').removeClass('is-menu-active');
    if(!isactive){
        $(this).parent().addClass('is-menu-active')
    }
})
}